/* eslint-disable import/no-extraneous-dependencies */
import 'react-advanced-cropper/dist/style.css'
import ImageCropper from '@/shared/components/ImageCropper/ImageCropper'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import { useCropImageStore } from '@/shared/store/useCropImageStore'

function CropImageModal() {
  const { t } = useTranslation()
  const {
    isOpen,
    slotId,
    imageUrl,
    imageShape,
    imageSize,
    stencilSize,
    close
  } = useCropImageStore()

  return (
    <Modal
      title={t('CROP_IMAGE_MODAL.TITLE')}
      size="fit-content"
      isOpen={isOpen}
      onClose={close}
    >
      <ImageCropper
        slotId={slotId!}
        imageSize={imageSize!}
        stencilSize={stencilSize!}
        imageUrl={imageUrl}
        shape={imageShape}
        onModalClose={close}
      />
    </Modal>
  )
}

export default CropImageModal
